import creditoService from '@/servicios/credito'
import { ERROR_OBTENER_FRECUENCIA_PLAZO_PRODUCTO } from '@/utilidades/errores'

export const ObtieneFrecuenciaPlazoProductoMixin = {
  data: () => ({
    consumiendoFrecPlazoPdcto: false,
  }),
  methods: {
    // Metodos publicos
    obtieneFrecuenciaPlazoProducto(idSubproducto = null, folioDigital = null) {
      this.$_ObtieneFrecuenciaPlazoProductoMixin_IniciaObtieneFrecuenciaPlazoProducto()
      creditoService
        .obtenerFrecuenciaPlazoProducto(idSubproducto, folioDigital)
        .then((result) => {
          this.$_ObtieneFrecuenciaPlazoProductoMixin_TerminaObtieneFrecuenciaPlazoProducto()
          if (result.status != 200) {
            this.errorObtieneFrecuenciaPlazoProducto(
              ERROR_OBTENER_FRECUENCIA_PLAZO_PRODUCTO
            )
            return
          }
          const data = result.data
          if (data.Codigo != 200) {
            this.errorObtieneFrecuenciaPlazoProducto(data.Mensaje)
            return
          }
          this.postObtieneFrecuenciaPlazoProducto(data.Modelo)
        })
        .catch((err) => {
          this.$_ObtieneFrecuenciaPlazoProductoMixin_TerminaObtieneFrecuenciaPlazoProducto()
          console.error(err)
          this.errorObtieneFrecuenciaPlazoProducto(
            ERROR_OBTENER_FRECUENCIA_PLAZO_PRODUCTO
          )
        })
    },
    postObtieneFrecuenciaPlazoProducto() {},
    errorObtieneFrecuenciaPlazoProducto(mensaje) {
      console.error(mensaje)
    },

    // Metodos privados
    $_ObtieneFrecuenciaPlazoProductoMixin_IniciaObtieneFrecuenciaPlazoProducto() {
      this.consumiendoFrecPlazoPdcto = true
    },
    $_ObtieneFrecuenciaPlazoProductoMixin_TerminaObtieneFrecuenciaPlazoProducto() {
      this.consumiendoFrecPlazoPdcto = false
    },
  },
}
